import styled from 'styled-components';
import PriceSuffixTemplate from './PriceSuffixTemplate';

export const PriceSuffixStyled = styled(PriceSuffixTemplate)`
    background: none;
`;
